'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var defaultPhrases = {};

exports.__exports = defaultPhrases;
